import React, { useEffect, useState } from "react";
import { FiCalendar } from "react-icons/fi";
import axiosInstance from "../../../axios/axios";
import { useParams } from "react-router-dom";
import moment from "moment";

import {
  Encrypt_Value,
  Decrypt_Value,
} from "../../../MiddleWare/EncryptDecrypt";

const RecentAppointmentsCard = ({ onExportData }) => {
  const params = useParams();

  const [data, setData] = useState([]);

  const getPastAppointmentsData = () => {
    let currentData = "pid=" + params.pid;

    let encryptedData = Encrypt_Value(currentData, "vozo");

    axiosInstance
      .get("/vozo/pastappointment?search=" + encryptedData)
      .then((response) => {
        let decodingResponse = Decrypt_Value(response.data, "vozo");

        const formatted = (
          Array.isArray(decodingResponse) ? decodingResponse : []
        ).map((item) => ({
          doctorName:
            "Dr. " + (item.userfname || "") + " " + (item.userlname || ""),

          facilityName: item.facility_name || "-",

          appointmentDate:
            item.pc_eventDate && item.pc_eventDate !== "0000-00-00"
              ? moment(item.pc_eventDate).format("MMM DD, YYYY")
              : "-",

          appointmentTime: item.pc_startTime || "-",
        }));

        /* UI → latest 3 */

        const latestThree = formatted.slice(0, 3);

        setData(latestThree);

        /* PARENT → FULL DATA */

        if (onExportData) {
          onExportData(
            formatted.map((item) => ({
              name: item.doctorName,
              place: item.facilityName,
              date:
                item.appointmentDate && item.appointmentTime
                  ? `${item.appointmentDate} at ${item.appointmentTime}`
                  : "-",
            })),
          );
        }
      })
      .catch(() => {
        setData([]);
      });
  };

  useEffect(() => {
    getPastAppointmentsData();
  }, [params.pid]);

  return (
    <div className="care-summary-card">
      <div className="care-summary-title-wrap">
        <FiCalendar className="care-summary-main-icon" />

        <h3 className="care-summary-title">Recent Appointments</h3>
      </div>

      <div className="care-summary-body">
        {data.length === 0 ? (
          <div className="care-summary-empty">No Recent Appointments Added</div>
        ) : (
          data.map((item, index) => (
            <div
              key={index}
              className={`care-summary-row-column ${
                index !== data.length - 1 ? "care-summary-border" : ""
              }`}
            >
              <div className="care-summary-heading">{item.doctorName}</div>

              <div className="care-summary-subtext dark-sub">
                {item.facilityName}
              </div>

              <div className="care-summary-subtext">
                {item.appointmentDate}
                {" at "}
                {item.appointmentTime}
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default React.memo(RecentAppointmentsCard);
